import * as React from 'react';
import { IconTypeMap } from '@mui/material';
import * as MUIcon from '@mui/icons-material';

type IconProps = IconTypeMap['props'];

interface MIconProps extends IconProps {
  name: string | undefined;
}

export default function AppIcon(props: MIconProps) {
  const { name } = props;
  const Icon = MUIcon[name as keyof typeof MUIcon];
  if (Icon == null) {
    throw `There is no "${name}" Icon`;
  }
  return <Icon {...props} />;
}
